import { createContext } from 'react';

const DefaultIsMobileContext = createContext<boolean | undefined>(undefined);

export default DefaultIsMobileContext;
